import React from "react";
import FlowContextProvider from "./FlowContextProvider";

export default function withFlowContextProvider<
  P extends React.JSX.IntrinsicAttributes,
>(
  WrappedComponent:
    | React.ComponentClass<P>
    | React.FC<React.PropsWithChildren<P>>
) {
  return (props: P) => (
    <FlowContextProvider>
      <WrappedComponent {...props} />
    </FlowContextProvider>
  );
}
